const categories = [
  { name: '动作片在线', icon: 'ri-sword-line', count: '2,860+', desc: '热血激战·拳拳到肉' },
  { name: '喜剧片免费看', icon: 'ri-emotion-happy-line', count: '1,950+', desc: '爆笑不断·治愈心情' },
  { name: '科幻片高清', icon: 'ri-rocket-line', count: '1,430+', desc: '脑洞大开·视觉盛宴' },
  { name: '悬疑惊悚', icon: 'ri-search-eye-line', count: '1,280+', desc: '烧脑反转·心跳加速' },
  { name: '爱情文艺', icon: 'ri-heart-line', count: '1,560+', desc: '温情浪漫·感动人心' },
  { name: '动画电影', icon: 'ri-palette-line', count: '1,140+', desc: '老少皆宜·奇思妙想' },
  { name: '经典电影全集', icon: 'ri-vip-crown-line', count: '980+', desc: '时光沉淀·不朽经典' },
  { name: '纪录片', icon: 'ri-earth-line', count: '760+', desc: '真实世界·深度探索' },
  { name: '恐怖片', icon: 'ri-ghost-line', count: '890+', desc: '惊声尖叫·胆量试炼' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          电影分类索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          九大分类，快速找到你想看的电影类型
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-4 bg-background-100 border border-background-200/60 rounded-lg p-4 hover:border-primary-500/30 transition-colors group cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors flex-shrink-0">
                <i className={`${cat.icon} text-primary-500 text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">{cat.desc}</div>
              </div>
              <div className="text-xs text-foreground-400 font-mono flex-shrink-0">
                {cat.count}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}